import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyCounter() {
  const [timeLeft, setTimeLeft] = useState(() => {
    // Start at 21 hours, 44 minutes, 44 seconds
    const saved = sessionStorage.getItem('urgency_end');
    if (saved) {
      const diff = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return diff;
    }
    const total = 21 * 3600 + 44 * 60 + 44;
    sessionStorage.setItem('urgency_end', String(Date.now() + total * 1000));
    return total;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section className="py-10 px-6 bg-[#0f0f23]" data-id="element-258">
      <div className="border-t border-red-500/40 border-b border-b-red-500/40 py-8" data-id="element-259">
        {/* Title */}
        <div className="flex items-center justify-center gap-2 mb-6" data-id="element-260">
          <Clock className="w-5 h-5 text-gray-300" data-id="element-261" />
          <p className="text-white font-black text-lg uppercase tracking-wider" data-id="element-262">
            Esta oferta termina en
          </p>
        </div>

        {/* Counter */}
        <div className="flex items-center justify-center gap-4 mb-6" data-id="element-263">
          <div className="text-center" data-id="element-264">
            <span className="text-yellow-400 text-5xl font-black leading-none block" data-id="element-265">
              {pad(hours)}
            </span>
            <span className="text-gray-500 text-[10px] uppercase tracking-widest mt-1 block" data-id="element-266">
              Horas
            </span>
          </div>
          <span className="text-gray-600 text-4xl font-bold -mt-4" data-id="element-267">:</span>
          <div className="text-center" data-id="element-268">
            <span className="text-red-400 text-5xl font-black leading-none block" data-id="element-269">
              {pad(minutes)}
            </span>
            <span className="text-gray-500 text-[10px] uppercase tracking-widest mt-1 block" data-id="element-270">
              Minutos
            </span>
          </div>
          <span className="text-gray-600 text-4xl font-bold -mt-4" data-id="element-271">:</span>
          <div className="text-center" data-id="element-272">
            <span className="text-red-400 text-5xl font-black leading-none block" data-id="element-273">
              {pad(seconds)}
            </span>
            <span className="text-gray-500 text-[10px] uppercase tracking-widest mt-1 block" data-id="element-274">
              Segundos
            </span>
          </div>
        </div>

        {/* Urgency text */}
        <p className="text-gray-400 text-sm text-center leading-relaxed italic max-w-sm mx-auto" data-id="element-275">
          Cuando el contador llegue a cero, estos regalos dejarán de estar
          incluidos y pasarán a tener un costo adicional.
        </p>
      </div>
    </section>;
}